// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cover_container__NLT3O {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border: 1px solid #E0E0E0;
  position: relative; }
  .cover_container__NLT3O .cover_editCover__BAo-w {
    position: absolute;
    bottom: -1px;
    left: 3px; }
    .cover_container__NLT3O .cover_editCover__BAo-w .cover_editCoverLabel__wwJFI {
      cursor: pointer; }
  .cover_container__NLT3O .cover_deleteCover__LdC-8 {
    position: absolute;
    bottom: 3px;
    right: 3px;
    cursor: pointer; }
  .cover_container__NLT3O .cover_cover__NWXxL {
    max-width: 80px;
    max-height: 80px; }
`, "",{"version":3,"sources":["webpack://./src/pages/company/components/cover/cover.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB,EAAA;EAPpB;IAUI,kBAAkB;IAClB,YAAY;IACZ,SAAS,EAAA;IAZb;MAeM,eAAe,EAAA;EAfrB;IAoBI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe,EAAA;EAvBnB;IA2BI,eAAe;IACf,gBAAgB,EAAA","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 80px;\n  height: 80px;\n  border: 1px solid #E0E0E0;\n  position: relative;\n\n  .editCover {\n    position: absolute;\n    bottom: -1px;\n    left: 3px;\n\n    .editCoverLabel {\n      cursor: pointer;\n    }\n  }\n\n  .deleteCover {\n    position: absolute;\n    bottom: 3px;\n    right: 3px;\n    cursor: pointer;\n  }\n\n  .cover {\n    max-width: 80px;\n    max-height: 80px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cover_container__NLT3O`,
	"editCover": `cover_editCover__BAo-w`,
	"editCoverLabel": `cover_editCoverLabel__wwJFI`,
	"deleteCover": `cover_deleteCover__LdC-8`,
	"cover": `cover_cover__NWXxL`
};
export default ___CSS_LOADER_EXPORT___;
